import { ReactElement, useContext } from "react"

import { AccountSetUpContext } from "./providers/firstLoginProvider"
import { FIRST_LOGIN_DISPATCHER } from "./screenDispatchers/firstLoginDispatcher"

/** Selects screen from context
 */
const ScreenPicker = (): ReactElement => {
    const { currentScreen } = useContext(AccountSetUpContext)
    return FIRST_LOGIN_DISPATCHER[currentScreen]
}

export default ScreenPicker
